var html = $('html');

$(function () {
    darkMode();
    portugueseMode();
    whiteLogo();
    carousel();
    video();
    author();
    offCanvas();
});

function darkMode() {
    $('.toggle-track').on('click', function () {
        if (html.hasClass('dark-mode')) {
            html.removeClass('dark-mode');
            localStorage.setItem('alto_dark', false);
        } else {
            html.addClass('dark-mode');
            localStorage.setItem('alto_dark', true);
        }
    });
}

function portugueseMode() {
    $('.toggle-track-language').on('click', function () {
        if (html.hasClass('ptbr-mode')) {
            html.removeClass('ptbr-mode');
            localStorage.setItem('language_portuguese', false);
            selected_tag = 'ENG';
            console.log(selected_tag);
            load_posts(selected_tag);
        } else {
            html.addClass('ptbr-mode');
            localStorage.setItem('language_portuguese', true);
            selected_tag = 'PT-BR';
            console.log(selected_tag);
            load_posts(selected_tag);
        }
    });
}

function load_posts(lang){
    var old_content = document.getElementsByClassName("post-feed")[0];
    var new_content = document.createElement("div");
    if (lang=="PT-BR") {
        new_content.innerHTML = document.getElementById("template_posts_ptbr").innerHTML;
    } else {
        new_content.innerHTML = document.getElementById("template_posts_eng").innerHTML;
    }
    old_content.parentNode.replaceChild(new_content,old_content)
}

function whiteLogo() {
    if (typeof gh_white_logo != 'undefined') {
        var whiteImage = '<img class="logo-image white" src="' + gh_white_logo + '">';
        $('.logo').append(whiteImage);
    }
}

function carousel() {
    var carousel = $('.carousel');
    var postImage = carousel.find('.post-image');
    var imageHeight, nav;

    function moveNav() {
        imageHeight = postImage.height();
        if (!nav) {
            nav = carousel.find('.owl-prev, .owl-next');
        }
        nav.css({
            top: imageHeight / 2 + 'px',
            opacity: 1,
        });
    }

    carousel.owlCarousel({
        dots: false,
        margin: 20,
        nav: true,
        navText: [
            '<i class="icon icon-chevron-left"></i>',
            '<i class="icon icon-chevron-right"></i>',
        ],
        onInitialized: function () {
            moveNav();
        },
        onResized: function () {
            moveNav();
        },
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 3,
            },
            992: {
                items: 4,
            },
        },
    });
}

function video() {
    'use strict';
    $('.post-content').fitVids();
}

function author() {
    $('.author-name').on('click', function () {
        $(this).next('.author-social').toggleClass('enabled');
    });
}

function offCanvas() {
    var burger = jQuery('.burger');
    var canvasClose = jQuery('.canvas-close');

    jQuery('.nav-list').slicknav({
        label: '',
        prependTo: '.mobile-menu',
    });

    burger.on('click', function () {
        html.toggleClass('canvas-opened');
        html.addClass('canvas-visible');
        dimmer('open', 'medium');
    });

    canvasClose.on('click', function () {
        if (html.hasClass('canvas-opened')) {
            html.removeClass('canvas-opened');
            dimmer('close', 'medium');
        }
    });

    jQuery('.dimmer').on('click', function () {
        if (html.hasClass('canvas-opened')) {
            html.removeClass('canvas-opened');
            dimmer('close', 'medium');
        }
    });

    jQuery(document).keyup(function (e) {
        if (e.keyCode == 27 && html.hasClass('canvas-opened')) {
            html.removeClass('canvas-opened');
            dimmer('close', 'medium');
        }
    });
}

function dimmer(action, speed) {
    'use strict';

    var dimmer = jQuery('.dimmer');

    switch (action) {
        case 'open':
            dimmer.fadeIn(speed);
            break;
        case 'close':
            dimmer.fadeOut(speed);
            break;
    }
}
